import React from 'react';

import styled from 'styled-components';

const ShopReviewsContainer = styled.div`
   width: 100%;
   height: 1000px;
   background: green;
`

const shopReviews = () =>{
    return(
       <ShopReviewsContainer>
           
       </ShopReviewsContainer>
    );
};

export default shopReviews;